import React from 'react';
import DataConsumer from './DataConsumer';

const shouldRenderChildren = (shouldHaveResults) => ({ children }) => (
	<DataConsumer>{({ hasNoResults }) => (!(shouldHaveResults ^ !hasNoResults) ? children : null)}</DataConsumer>
);

export const WithResults = shouldRenderChildren(true);
export const WithoutResults = shouldRenderChildren(false);
